import { DocumentDirection } from '../config/DocumentDirection';

const formatDecimalWithGrouping = (val, maximumFractionDigits) => {
  const formatterOptions = {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits,
  };

  try {
    return new Intl.NumberFormat('hu-HU', {
      ...formatterOptions,
      useGrouping: 'always',
    }).format(val);
  } catch (_error) {
    return new Intl.NumberFormat('hu-HU', {
      ...formatterOptions,
      useGrouping: true,
    }).format(val);
  }
};

export const formatCurrency = (val, fractionDigits = 2) => {
  return formatDecimalWithGrouping(val, fractionDigits);
};

export const formatNumber = (val) => {
  return formatDecimalWithGrouping(val, 6);
};

export const getRounding = (docDirection, currency) => {
  if (docDirection === DocumentDirection.INCOMING) {
    return currency?.purchasePriceRounding ?? 0;
  } else {
    return currency?.priceRounding ?? 0;
  }
};
